// Exporting countries in english
export const COUNTRIES_EN = {
  'COUNTRY': {
    'ax': 'Aaland Islands',
    'af': 'Afghanistan',
    'al': 'Albania',
    'dz': 'Algeria',
    'as': 'American Samoa',
    'ad': 'Andorra',
    'ao': 'Angola',
    'ai': 'Anguilla',
    'aq': 'Antarctica',
    'ag': 'Antigua And Barbuda',
    'ar': 'Argentina',
    'am': 'Armenia',
    'aw': 'Aruba',
    'au': 'Australia',
    'at': 'Austria',
    'az': 'Azerbaijan',
    'bs': 'Bahamas',
    'bh': 'Bahrain',
    'bd': 'Bangladesh',
    'bb': 'Barbados',
    'by': 'Belarus',
    'be': 'Belgium',
    'bz': 'Belize',
    'bj': 'Benin',
    'bm': 'Bermuda',
    'bt': 'Bhutan',
    'bo': 'Bolivia',
    'ba': 'Bosnia And Herzegowina',
    'bw': 'Botswana',
    'bv': 'Bouvet Island',
    'br': 'Brazil',
    'io': 'British Indian Ocean Territory',
    'bn': 'Brunei Darussalam',
    'bg': 'Bulgaria',
    'bf': 'Burkina Faso',
    'bi': 'Burundi',
    'kh': 'Cambodia',
    'cm': 'Cameroon',
    'ca': 'Canada',
    'cv': 'Cape Verde',
    'bq': 'Caribbean Netherlands',
    'ky': 'Cayman Islands',
    'cf': 'Central African Republic',
    'td': 'Chad',
    'cl': 'Chile',
    'cn': 'China',
    'cx': 'Christmas Island',
    'cc': 'Cocos Islands',
    'co': 'Colombia',
    'km': 'Comoros',
    'cg': 'Congo Republic',
    'cd': 'Congo',
    'ck': 'Cook Islands',
    'cr': 'Costa Rica',
    'ci': 'Cote Divoire',
    'hr': 'Croatia ',
    'cu': 'Cuba',
    'cw': 'Curacao',
    'cy': 'Cyprus',
    'cz': 'Czech Republic',
    'dk': 'Denmark',
    'dj': 'Djibouti',
    'dm': 'Dominica',
    'do': 'Dominican Republic',
    'ec': 'Ecuador',
    'eg': 'Egypt',
    'sv': 'El Salvador',
    'gq': 'Equatorial Guinea',
    'er': 'Eritrea',
    'ee': 'Estonia',
    'et': 'Ethiopia',
    'fk': 'Falkland Islands (malvinas)',
    'fo': 'Faroe Islands',
    'fj': 'Fiji',
    'fi': 'Finland',
    'fr': 'France',
    'gf': 'French Guiana',
    'pf': 'French Polynesia',
    'tf': 'French Southern Territories',
    'ga': 'Gabon',
    'gm': 'Gambia',
    'ge': 'Georgia',
    'de': 'Germany',
    'gh': 'Ghana',
    'gi': 'Gibraltar',
    'gr': 'Greece',
    'gl': 'Greenland',
    'gd': 'Grenada',
    'gp': 'Guadeloupe',
    'gu': 'Guam',
    'gt': 'Guatemala',
    'gg': 'Guernsey',
    'gn': 'Guinea',
    'gw': 'Guinea-bissau',
    'gy': 'Guyana',
    'ht': 'Haiti',
    'hm': 'Heard And Mc Donald Islands',
    'hn': 'Honduras',
    'hk': 'Hong Kong',
    'hu': 'Hungary',
    'is': 'Iceland',
    'in': 'India',
    'id': 'Indonesia',
    'ir': 'Iran ',
    'iq': 'Iraq',
    'ie': 'Ireland',
    'im': 'Isle of Man',
    'il': 'Israel',
    'it': 'Italy',
    'jm': 'Jamaica',
    'jp': 'Japan',
    'je': 'Jersey',
    'jo': 'Jordan',
    'kz': 'Kazakhstan',
    'ke': 'Kenya',
    'ki': 'Kiribati',
    'kp': 'North Korea',
    'kr': 'South Korea',
    'xk': 'Kosovo',
    'kw': 'Kuwait',
    'kg': 'Kyrgyzstan',
    'la': 'Lao',
    'lv': 'Latvia',
    'lb': 'Lebanon',
    'ls': 'Lesotho',
    'lr': 'Liberia',
    'ly': 'Libyan Arab Jamahiriya',
    'li': 'Liechtenstein',
    'lt': 'Lithuania',
    'lu': 'Luxembourg',
    'mo': 'Macau',
    'mk': 'Macedonia',
    'mg': 'Madagascar',
    'mw': 'Malawi',
    'my': 'Malaysia',
    'mv': 'Maldives',
    'ml': 'Mali',
    'mt': 'Malta',
    'mh': 'Marshall Islands',
    'mq': 'Martinique',
    'mr': 'Mauritania',
    'mu': 'Mauritius',
    'yt': 'Mayotte',
    'mx': 'Mexico',
    'fm': 'Micronesia',
    'md': 'Moldova',
    'mc': 'Monaco',
    'mn': 'Mongolia',
    'me': 'Montenegro',
    'ms': 'Montserrat',
    'ma': 'Morocco',
    'mz': 'Mozambique',
    'mm': 'Myanmar',
    'na': 'Namibia',
    'nr': 'Nauru',
    'np': 'Nepal',
    'an': 'Netherlands Antilles',
    'nl': 'Netherlands',
    'nc': 'New Caledonia',
    'nz': 'New Zealand',
    'ni': 'Nicaragua',
    'ne': 'Niger',
    'ng': 'Nigeria',
    'nu': 'Niue',
    'nf': 'Norfolk Island',
    'mp': 'Northern Mariana Islands',
    'no': 'Norway',
    'om': 'Oman',
    'pk': 'Pakistan',
    'pw': 'Palau',
    'ps': 'Palestina',
    'pa': 'Panama',
    'pg': 'Papua New Guinea',
    'py': 'Paraguay',
    'pe': 'Peru',
    'ph': 'Philippines',
    'pn': 'Pitcairn',
    'pl': 'Poland',
    'pt': 'Portugal',
    'pr': 'Puerto Rico',
    'qa': 'Qatar',
    're': 'Reunion',
    'ro': 'Romania',
    'ru': 'Russian Federation',
    'rw': 'Rwanda',
    'sh': 'Saint Helena',
    'kn': 'Saint Kitts And Nevis',
    'lc': 'Saint Lucia',
    'pm': 'Saint Pierre And Miquelon',
    'vc': 'Saint Vincent And The Grenadines',
    'ws': 'Samoa',
    'bl': 'San Bartolomé',
    'sm': 'San Marino',
    'st': 'Sao Tome And Principe',
    'sa': 'Saudi Arabia',
    'sn': 'Senegal',
    'cs': 'Serbia And Montenegro',
    'rs': 'Serbia',
    'sc': 'Seychelles',
    'sl': 'Sierra Leone',
    'sg': 'Singapore',
    'sx': 'Sint Maarten',
    'sk': 'Slovakia',
    'si': 'Slovenia',
    'sb': 'Solomon Islands',
    'so': 'Somalia',
    'za': 'South Africa',
    'gs': 'South Georgia Islands',
    'ss': 'South Sudan',
    'es': 'Spain',
    'lk': 'Sri Lanka',
    'sd': 'Sudan',
    'sr': 'Suriname',
    'sj': 'Svalbard And Jan Mayen Islands',
    'sz': 'Swaziland',
    'se': 'Sweden',
    'ch': 'Switzerland',
    'sy': 'Syrian Arab Republic',
    'tw': 'Taiwan',
    'tj': 'Tajikistan',
    'tz': 'Tanzania',
    'th': 'Thailand',
    'tl': 'Timor-leste',
    'tg': 'Togo',
    'tk': 'Tokelau',
    'to': 'Tonga',
    'tt': 'Trinidad And Tobago',
    'tn': 'Tunisia',
    'tr': 'Turkey',
    'tm': 'Turkmenistan',
    'tc': 'Turks And Caicos Islands',
    'tv': 'Tuvalu',
    'ug': 'Uganda',
    'ua': 'Ukraine',
    'ae': 'United Arab Emirates',
    'gb': 'United Kingdom',
    'um': 'United States Minor Outlying Islands',
    'us': 'United States',
    'uy': 'Uruguay',
    'uz': 'Uzbekistan',
    'vu': 'Vanuatu',
    'va': 'Vatican City State',
    've': 'Venezuela',
    'vn': 'Viet Nam',
    'vg': 'Virgin Islands (British)',
    'vi': 'Virgin Islands (U.S.)',
    'wf': 'Wallis And Futuna Islands',
    'eh': 'Western Sahara',
    'ye': 'Yemen',
    'zm': 'Zambia',
    'zw': 'Zimbabwe'
  }
};

// exporting countries in spanish
export const COUNTRIES_ES = {
  'COUNTRY': {
    'af': 'Afghanistán',
    'al': 'Albania',
    'de': 'Alemania',
    'ad': 'Andorra',
    'ao': 'Angola',
    'ai': 'Anguila',
    'ag': 'Antigua Y Barbuda',
    'an': 'Antillas Neerlandesas',
    'aq': 'Antártida',
    'sa': 'Arabia Saudita',
    'dz': 'Argel',
    'ar': 'Argentina',
    'am': 'Armenia',
    'aw': 'Aruba',
    'au': 'Australia',
    'at': 'Austria',
    'az': 'Azerbaiyán',
    'bs': 'Bahamas',
    'bh': 'Bahréin',
    'bd': 'Bangladesh',
    'bb': 'Barbados',
    'by': 'Belarús',
    'bz': 'Belice',
    'bj': 'Benin',
    'bm': 'Bermudaas',
    'bt': 'Bhután',
    'bo': 'Bolivia',
    'ba': 'Bosnia Y Herzegovina',
    'bw': 'Botsuana',
    'br': 'Brasil',
    'bn': 'Brunéi',
    'bg': 'Bulgaria',
    'bf': 'Burkina Faso',
    'bi': 'Burundi',
    'be': 'Bélgica',
    'cv': 'Cabo Verde',
    'kh': 'Camboya',
    'cm': 'Camerún',
    'ca': 'Canadá',
    'bq': 'Caribe Países Bajos',
    'td': 'Chad',
    'cl': 'Chile',
    'cn': 'China',
    'cy': 'Chipre',
    'va': 'Ciudad Del Vaticano',
    'co': 'Colombia',
    'km': 'Comoros',
    'cd': 'Congo (zaire)',
    'cg': 'Congo',
    'ci': 'Costa De Marfil',
    'cr': 'Costa Rica',
    'hr': 'Croacia ',
    'cu': 'Cuba',
    'cw': 'Curaçao',
    'dk': 'Dinamarca',
    'dm': 'Domínica',
    'ec': 'Ecuador',
    'eg': 'Egipto',
    'sv': 'El Salvador',
    'ae': 'Emiratos Árabes Unidos',
    'er': 'Eritrea',
    'sk': 'Eslovaquia',
    'si': 'Eslovenia',
    'es': 'España',
    'us': 'Estados Unidos De América',
    'um': 'Estados Unidos Islas Minor Outlying',
    'ee': 'Estonia',
    'et': 'Etiopía',
    'fj': 'Fiji',
    'ph': 'Filipinas',
    'fi': 'Finlandia',
    'fr': 'Francia',
    'ga': 'Gabón',
    'gm': 'Gambia',
    'gs': 'Georgia Del Sur E Islas Sandwich Del Sur',
    'ge': 'Georgia',
    'gh': 'Ghana',
    'gi': 'Gibraltar',
    'gd': 'Granada',
    'gr': 'Greece',
    'gl': 'Groenlandia',
    'gp': 'Guadalupe',
    'gu': 'Guam',
    'gt': 'Guatemala',
    'gg': 'Guernsey',
    'gf': 'Guiana Francesa',
    'gq': 'Guinea Ecuatorial',
    'gn': 'Guinea',
    'gw': 'Guinea-bissau',
    'gy': 'Guyana',
    'ht': 'Haiti',
    'hn': 'Honduras',
    'hk': 'Hong Kong',
    'hu': 'Hungría',
    'in': 'India',
    'id': 'Indonesia',
    'iq': 'Irak',
    'ie': 'Irlanda',
    'ir': 'Irán',
    'bv': 'Isla Bouvet',
    'im': 'Isla De Man',
    'is': 'Islandia',
    'ky': 'Islas Caimán',
    'cx': 'Islas Christmas',
    'cc': 'Islas Cocos',
    'ck': 'Islas Cook',
    'fo': 'Islas Faroe',
    'hm': 'Islas Heard Y Mc Donald',
    'fk': 'Islas Malvinas',
    'mp': 'Islas Marianas Del Norte',
    'mh': 'Islas Marshall',
    'nf': 'Islas Norkfolk',
    'pw': 'Islas Palaos',
    'pn': 'Islas Pitcairn',
    'sb': 'Islas Solomón',
    'sj': 'Islas Svalbard Y Jan Mayen',
    'tc': 'Islas Turcas Y Caicos',
    'vg': 'Islas Vírgenes (inglesas)',
    'vi': 'Islas Vírgenes (u.s.)',
    'ax': 'Islas Áland',
    'il': 'Israel',
    'it': 'Italia',
    'jm': 'Jamaica',
    'jp': 'Japón',
    'je': 'Jersey',
    'jo': 'Jordania',
    'kz': 'Kazajstán',
    'ke': 'Kenia',
    'kg': 'Kirguistán',
    'ki': 'Kiribati',
    'kp': 'Korea Del Norte',
    'kr': 'Korea Del Sur',
    'xk': 'Kosovo',
    'kw': 'Kuwait',
    'la': 'Laos',
    'ls': 'Lesotho',
    'lv': 'Letonia',
    'lr': 'Liberia',
    'ly': 'Libia',
    'li': 'Liechtenstein',
    'lt': 'Lituania',
    'lu': 'Luxemburgo',
    'lb': 'Líbano',
    'mo': 'Macao',
    'mk': 'Macedonia',
    'mg': 'Madagascar',
    'my': 'Malasia',
    'mw': 'Malawi',
    'mv': 'Maldivas',
    'ml': 'Mali',
    'mt': 'Malta',
    'ma': 'Marruecos',
    'mq': 'Matinica',
    'mu': 'Mauricio',
    'mr': 'Mauritania',
    'yt': 'Mayotte',
    'fm': 'Micronesia',
    'md': 'Moldova',
    'mn': 'Mongolia',
    'me': 'Montenegro',
    'ms': 'Montserrat',
    'mz': 'Mozambique',
    'mm': 'Myanmar',
    'mx': 'México',
    'mc': 'Mónaco',
    'na': 'Namibia',
    'nr': 'Nauru',
    'np': 'Nepal',
    'ni': 'Nicaragua',
    'ng': 'Nigeria',
    'nu': 'Niue',
    'no': 'Noruega',
    'nc': 'Nueva Caledonia',
    'nz': 'Nueva Zelanda',
    'ne': 'Níger',
    'om': 'Omán',
    'pk': 'Pakistán',
    'ps': 'Palestina',
    'pa': 'Panamá',
    'pg': 'Papúa Nueva Guinea',
    'py': 'Paraguay',
    'nl': 'Países Bajos',
    'pe': 'Perú',
    'pl': 'Polonia',
    'pf': 'Polynesia Francesa',
    'pt': 'Portugal',
    'pr': 'Puerto Rico',
    'qa': 'Qatar',
    'gb': 'Reino Unido',
    'cf': 'República Centro-africana',
    'cz': 'República Checa',
    'do': 'República Dominicana',
    're': 'Reunión',
    'rw': 'Ruanda',
    'ro': 'Rumanía',
    'ru': 'Rusia',
    'eh': 'Sahara Occidental',
    'as': 'Samoa Americana',
    'ws': 'Samoa',
    'bl': 'San Bartolomé',
    'kn': 'San Cristóbal Y Nieves',
    'sm': 'San Marino',
    'pm': 'San Pedro Y Miquelón',
    'vc': 'San Vicente Y Las Granadinas',
    'sh': 'Santa Elena',
    'lc': 'Santa Lucía',
    'st': 'Santo Tomé Y Príncipe',
    'sn': 'Senegal',
    'cs': 'Serbia Y Montenegro',
    'rs': 'Serbia',
    'sc': 'Seychelles',
    'sl': 'Sierra Leona',
    'sg': 'Singapur',
    'sx': 'Sint Maarten',
    'sy': 'Siria',
    'so': 'Somalia',
    'lk': 'Sri Lanka',
    'sz': 'Suazilandia',
    'za': 'Sudáfrica',
    'ss': 'Sudán Del Sur',
    'sd': 'Sudán',
    'se': 'Suecia',
    'ch': 'Suiza',
    'sr': 'Surinam',
    'th': 'Tailandia',
    'tw': 'Taiwán',
    'tz': 'Tanzania',
    'tj': 'Tayikistán',
    'io': 'Territorio Británico Del Océano Índico',
    'tf': 'Territorios Australes Franceses',
    'tl': 'Timor-leste',
    'tg': 'Togo',
    'tk': 'Tokelau',
    'to': 'Tonga',
    'tt': 'Trinidad Y Tobago',
    'tm': 'Turkmenistán',
    'tr': 'Turquía',
    'tv': 'Tuvalu',
    'tn': 'Túnez',
    'ua': 'Ucrania',
    'ug': 'Uganda',
    'uy': 'Uruguay',
    'uz': 'Uzbekistán',
    'vu': 'Vanuatu',
    've': 'Venezuela',
    'vn': 'Vietnam',
    'wf': 'Wallis Y Futuna',
    'ye': 'Yemen',
    'dj': 'Yibuti',
    'zm': 'Zambia',
    'zw': 'Zimbabue'
  }
};

// exporting countries in french
export const COUNTRIES_FR = {
  'COUNTRY': {
    'af': 'Afghanistan',
    'al': 'Albanie',
    'de': 'Allemagne',
    'ad': 'Andorre',
    'ao': 'Angola',
    'ai': 'Anguila',
    'ag': 'Antigua-et-Barbuda',
    'an': 'Antilles Pays-Bas',
    'aq': 'Antarctique',
    'sa': 'Arabie Saoudite',
    'dz': 'Algérie',
    'ar': 'Argentine',
    'am': 'Arménie',
    'aw': 'Aruba',
    'au': 'Australie',
    'at': 'Autriche',
    'az': 'Azerbaïdjan',
    'bs': 'Bahamas',
    'bh': 'Bahreïn',
    'bd': 'Bangladesh',
    'bb': 'Barbade',
    'by': 'Biélorussie',
    'bz': 'Belize',
    'bj': 'Bénin',
    'bm': 'Bermudes',
    'bt': 'Bhoutan',
    'bo': 'Bolivie',
    'ba': 'Bosnie-Herzégovine',
    'bw': 'Botswana',
    'br': 'Brésil',
    'bn': 'Brunéi',
    'bg': 'Bulgarie',
    'bf': 'Burkina',
    'bi': 'Burundi',
    'be': 'Bélgica',
    'cv': 'Cabo Verde',
    'kh': 'Camboya',
    'cm': 'Camerún',
    'ca': 'Canadá',
    'bq': 'Caribe Países Bajos',
    'td': 'Chad',
    'cl': 'Chile',
    'cn': 'China',
    'cy': 'Chipre',
    'va': 'Ciudad Del Vaticano',
    'co': 'Colombia',
    'km': 'Comoros',
    'cd': 'Congo (zaire)',
    'cg': 'Congo',
    'ci': 'Costa De Marfil',
    'cr': 'Costa Rica',
    'hr': 'Croacia ',
    'cu': 'Cuba',
    'cw': 'Curaçao',
    'dk': 'Dinamarca',
    'dm': 'Domínica',
    'ec': 'Ecuador',
    'eg': 'Egipto',
    'sv': 'El Salvador',
    'ae': 'Emiratos Árabes Unidos',
    'er': 'Eritrea',
    'sk': 'Eslovaquia',
    'si': 'Eslovenia',
    'es': 'España',
    'us': 'Estados Unidos De América',
    'um': 'Estados Unidos Islas Minor Outlying',
    'ee': 'Estonia',
    'et': 'Etiopía',
    'fj': 'Fiji',
    'ph': 'Filipinas',
    'fi': 'Finlandia',
    'fr': 'Francia',
    'ga': 'Gabón',
    'gm': 'Gambia',
    'gs': 'Georgia Del Sur E Islas Sandwich Del Sur',
    'ge': 'Georgia',
    'gh': 'Ghana',
    'gi': 'Gibraltar',
    'gd': 'Granada',
    'gr': 'Greece',
    'gl': 'Groenlandia',
    'gp': 'Guadalupe',
    'gu': 'Guam',
    'gt': 'Guatemala',
    'gg': 'Guernsey',
    'gf': 'Guiana Francesa',
    'gq': 'Guinea Ecuatorial',
    'gn': 'Guinea',
    'gw': 'Guinea-bissau',
    'gy': 'Guyana',
    'ht': 'Haiti',
    'hn': 'Honduras',
    'hk': 'Hong Kong',
    'hu': 'Hungría',
    'in': 'India',
    'id': 'Indonesia',
    'iq': 'Irak',
    'ie': 'Irlanda',
    'ir': 'Irán',
    'bv': 'Isla Bouvet',
    'im': 'Isla De Man',
    'is': 'Islandia',
    'ky': 'Islas Caimán',
    'cx': 'Islas Christmas',
    'cc': 'Islas Cocos',
    'ck': 'Islas Cook',
    'fo': 'Islas Faroe',
    'hm': 'Islas Heard Y Mc Donald',
    'fk': 'Islas Malvinas',
    'mp': 'Islas Marianas Del Norte',
    'mh': 'Islas Marshall',
    'nf': 'Islas Norkfolk',
    'pw': 'Islas Palaos',
    'pn': 'Islas Pitcairn',
    'sb': 'Islas Solomón',
    'sj': 'Islas Svalbard Y Jan Mayen',
    'tc': 'Islas Turcas Y Caicos',
    'vg': 'Islas Vírgenes (inglesas)',
    'vi': 'Islas Vírgenes (u.s.)',
    'ax': 'Islas Áland',
    'il': 'Israel',
    'it': 'Italia',
    'jm': 'Jamaica',
    'jp': 'Japón',
    'je': 'Jersey',
    'jo': 'Jordania',
    'kz': 'Kazajstán',
    'ke': 'Kenia',
    'kg': 'Kirguistán',
    'ki': 'Kiribati',
    'kp': 'Korea Del Norte',
    'kr': 'Korea Del Sur',
    'xk': 'Kosovo',
    'kw': 'Kuwait',
    'la': 'Laos',
    'ls': 'Lesotho',
    'lv': 'Letonia',
    'lr': 'Liberia',
    'ly': 'Libia',
    'li': 'Liechtenstein',
    'lt': 'Lituania',
    'lu': 'Luxemburgo',
    'lb': 'Líbano',
    'mo': 'Macao',
    'mk': 'Macedonia',
    'mg': 'Madagascar',
    'my': 'Malasia',
    'mw': 'Malawi',
    'mv': 'Maldivas',
    'ml': 'Mali',
    'mt': 'Malta',
    'ma': 'Marruecos',
    'mq': 'Matinica',
    'mu': 'Mauricio',
    'mr': 'Mauritania',
    'yt': 'Mayotte',
    'fm': 'Micronesia',
    'md': 'Moldova',
    'mn': 'Mongolia',
    'me': 'Montenegro',
    'ms': 'Montserrat',
    'mz': 'Mozambique',
    'mm': 'Myanmar',
    'mx': 'México',
    'mc': 'Mónaco',
    'na': 'Namibia',
    'nr': 'Nauru',
    'np': 'Nepal',
    'ni': 'Nicaragua',
    'ng': 'Nigeria',
    'nu': 'Niue',
    'no': 'Noruega',
    'nc': 'Nueva Caledonia',
    'nz': 'Nueva Zelanda',
    'ne': 'Níger',
    'om': 'Omán',
    'pk': 'Pakistán',
    'ps': 'Palestina',
    'pa': 'Panamá',
    'pg': 'Papúa Nueva Guinea',
    'py': 'Paraguay',
    'nl': 'Países Bajos',
    'pe': 'Perú',
    'pl': 'Polonia',
    'pf': 'Polynesia Francesa',
    'pt': 'Portugal',
    'pr': 'Puerto Rico',
    'qa': 'Qatar',
    'gb': 'Reino Unido',
    'cf': 'República Centro-africana',
    'cz': 'República Checa',
    'do': 'República Dominicana',
    're': 'Reunión',
    'rw': 'Ruanda',
    'ro': 'Rumanía',
    'ru': 'Rusia',
    'eh': 'Sahara Occidental',
    'as': 'Samoa Americana',
    'ws': 'Samoa',
    'bl': 'San Bartolomé',
    'kn': 'San Cristóbal Y Nieves',
    'sm': 'San Marino',
    'pm': 'San Pedro Y Miquelón',
    'vc': 'San Vicente Y Las Granadinas',
    'sh': 'Santa Elena',
    'lc': 'Santa Lucía',
    'st': 'Santo Tomé Y Príncipe',
    'sn': 'Senegal',
    'cs': 'Serbia Y Montenegro',
    'rs': 'Serbia',
    'sc': 'Seychelles',
    'sl': 'Sierra Leona',
    'sg': 'Singapur',
    'sx': 'Sint Maarten',
    'sy': 'Siria',
    'so': 'Somalia',
    'lk': 'Sri Lanka',
    'sz': 'Suazilandia',
    'za': 'Sudáfrica',
    'ss': 'Sudán Del Sur',
    'sd': 'Sudán',
    'se': 'Suecia',
    'ch': 'Suiza',
    'sr': 'Surinam',
    'th': 'Tailandia',
    'tw': 'Taiwán',
    'tz': 'Tanzania',
    'tj': 'Tayikistán',
    'io': 'Territorio Británico Del Océano Índico',
    'tf': 'Territorios Australes Franceses',
    'tl': 'Timor-leste',
    'tg': 'Togo',
    'tk': 'Tokelau',
    'to': 'Tonga',
    'tt': 'Trinidad Y Tobago',
    'tm': 'Turkmenistán',
    'tr': 'Turquía',
    'tv': 'Tuvalu',
    'tn': 'Túnez',
    'ua': 'Ucrania',
    'ug': 'Uganda',
    'uy': 'Uruguay',
    'uz': 'Uzbekistán',
    'vu': 'Vanuatu',
    've': 'Venezuela',
    'vn': 'Vietnam',
    'wf': 'Wallis Y Futuna',
    'ye': 'Yemen',
    'dj': 'Yibuti',
    'zm': 'Zambia',
    'zw': 'Zimbabue'
  }
};

export const COUNTRIES_DE = {
  'COUNTRY': {
    'ax': 'Aaland Islands',
    'af': 'Afghanistan',
    'al': 'Albania',
    'dz': 'Algeria',
    'as': 'American Samoa',
    'ad': 'Andorra',
    'ao': 'Angola',
    'ai': 'Anguilla',
    'aq': 'Antarctica',
    'ag': 'Antigua And Barbuda',
    'ar': 'Argentina',
    'am': 'Armenia',
    'aw': 'Aruba',
    'au': 'Australia',
    'at': 'Austria',
    'az': 'Azerbaijan',
    'bs': 'Bahamas',
    'bh': 'Bahrain',
    'bd': 'Bangladesh',
    'bb': 'Barbados',
    'by': 'Belarus',
    'be': 'Belgium',
    'bz': 'Belize',
    'bj': 'Benin',
    'bm': 'Bermuda',
    'bt': 'Bhutan',
    'bo': 'Bolivia',
    'ba': 'Bosnia And Herzegowina',
    'bw': 'Botswana',
    'bv': 'Bouvet Island',
    'br': 'Brazil',
    'io': 'British Indian Ocean Territory',
    'bn': 'Brunei Darussalam',
    'bg': 'Bulgaria',
    'bf': 'Burkina Faso',
    'bi': 'Burundi',
    'kh': 'Cambodia',
    'cm': 'Cameroon',
    'ca': 'Canada',
    'cv': 'Cape Verde',
    'bq': 'Caribbean Netherlands',
    'ky': 'Cayman Islands',
    'cf': 'Central African Republic',
    'td': 'Chad',
    'cl': 'Chile',
    'cn': 'China',
    'cx': 'Christmas Island',
    'cc': 'Cocos Islands',
    'co': 'Colombia',
    'km': 'Comoros',
    'cg': 'Congo Republic',
    'cd': 'Congo',
    'ck': 'Cook Islands',
    'cr': 'Costa Rica',
    'ci': 'Cote Divoire',
    'hr': 'Croatia ',
    'cu': 'Cuba',
    'cw': 'Curacao',
    'cy': 'Cyprus',
    'cz': 'Czech Republic',
    'dk': 'Denmark',
    'dj': 'Djibouti',
    'dm': 'Dominica',
    'do': 'Dominican Republic',
    'ec': 'Ecuador',
    'eg': 'Egypt',
    'sv': 'El Salvador',
    'gq': 'Equatorial Guinea',
    'er': 'Eritrea',
    'ee': 'Estonia',
    'et': 'Ethiopia',
    'fk': 'Falkland Islands (malvinas)',
    'fo': 'Faroe Islands',
    'fj': 'Fiji',
    'fi': 'Finland',
    'fr': 'France',
    'gf': 'French Guiana',
    'pf': 'French Polynesia',
    'tf': 'French Southern Territories',
    'ga': 'Gabon',
    'gm': 'Gambia',
    'ge': 'Georgia',
    'de': 'Germany',
    'gh': 'Ghana',
    'gi': 'Gibraltar',
    'gr': 'Greece',
    'gl': 'Greenland',
    'gd': 'Grenada',
    'gp': 'Guadeloupe',
    'gu': 'Guam',
    'gt': 'Guatemala',
    'gg': 'Guernsey',
    'gn': 'Guinea',
    'gw': 'Guinea-bissau',
    'gy': 'Guyana',
    'ht': 'Haiti',
    'hm': 'Heard And Mc Donald Islands',
    'hn': 'Honduras',
    'hk': 'Hong Kong',
    'hu': 'Hungary',
    'is': 'Iceland',
    'in': 'India',
    'id': 'Indonesia',
    'ir': 'Iran ',
    'iq': 'Iraq',
    'ie': 'Ireland',
    'im': 'Isle of Man',
    'il': 'Israel',
    'it': 'Italy',
    'jm': 'Jamaica',
    'jp': 'Japan',
    'je': 'Jersey',
    'jo': 'Jordan',
    'kz': 'Kazakhstan',
    'ke': 'Kenya',
    'ki': 'Kiribati',
    'kp': 'North Korea',
    'kr': 'South Korea',
    'xk': 'Kosovo',
    'kw': 'Kuwait',
    'kg': 'Kyrgyzstan',
    'la': 'Lao',
    'lv': 'Latvia',
    'lb': 'Lebanon',
    'ls': 'Lesotho',
    'lr': 'Liberia',
    'ly': 'Libyan Arab Jamahiriya',
    'li': 'Liechtenstein',
    'lt': 'Lithuania',
    'lu': 'Luxembourg',
    'mo': 'Macau',
    'mk': 'Macedonia',
    'mg': 'Madagascar',
    'mw': 'Malawi',
    'my': 'Malaysia',
    'mv': 'Maldives',
    'ml': 'Mali',
    'mt': 'Malta',
    'mh': 'Marshall Islands',
    'mq': 'Martinique',
    'mr': 'Mauritania',
    'mu': 'Mauritius',
    'yt': 'Mayotte',
    'mx': 'Mexico',
    'fm': 'Micronesia',
    'md': 'Moldova',
    'mc': 'Monaco',
    'mn': 'Mongolia',
    'me': 'Montenegro',
    'ms': 'Montserrat',
    'ma': 'Morocco',
    'mz': 'Mozambique',
    'mm': 'Myanmar',
    'na': 'Namibia',
    'nr': 'Nauru',
    'np': 'Nepal',
    'an': 'Netherlands Antilles',
    'nl': 'Netherlands',
    'nc': 'New Caledonia',
    'nz': 'New Zealand',
    'ni': 'Nicaragua',
    'ne': 'Niger',
    'ng': 'Nigeria',
    'nu': 'Niue',
    'nf': 'Norfolk Island',
    'mp': 'Northern Mariana Islands',
    'no': 'Norway',
    'om': 'Oman',
    'pk': 'Pakistan',
    'pw': 'Palau',
    'ps': 'Palestina',
    'pa': 'Panama',
    'pg': 'Papua New Guinea',
    'py': 'Paraguay',
    'pe': 'Peru',
    'ph': 'Philippines',
    'pn': 'Pitcairn',
    'pl': 'Poland',
    'pt': 'Portugal',
    'pr': 'Puerto Rico',
    'qa': 'Qatar',
    're': 'Reunion',
    'ro': 'Romania',
    'ru': 'Russian Federation',
    'rw': 'Rwanda',
    'sh': 'Saint Helena',
    'kn': 'Saint Kitts And Nevis',
    'lc': 'Saint Lucia',
    'pm': 'Saint Pierre And Miquelon',
    'vc': 'Saint Vincent And The Grenadines',
    'ws': 'Samoa',
    'bl': 'San Bartolomé',
    'sm': 'San Marino',
    'st': 'Sao Tome And Principe',
    'sa': 'Saudi Arabia',
    'sn': 'Senegal',
    'cs': 'Serbia And Montenegro',
    'rs': 'Serbia',
    'sc': 'Seychelles',
    'sl': 'Sierra Leone',
    'sg': 'Singapore',
    'sx': 'Sint Maarten',
    'sk': 'Slovakia',
    'si': 'Slovenia',
    'sb': 'Solomon Islands',
    'so': 'Somalia',
    'za': 'South Africa',
    'gs': 'South Georgia Islands',
    'ss': 'South Sudan',
    'es': 'Spain',
    'lk': 'Sri Lanka',
    'sd': 'Sudan',
    'sr': 'Suriname',
    'sj': 'Svalbard And Jan Mayen Islands',
    'sz': 'Swaziland',
    'se': 'Sweden',
    'ch': 'Switzerland',
    'sy': 'Syrian Arab Republic',
    'tw': 'Taiwan',
    'tj': 'Tajikistan',
    'tz': 'Tanzania',
    'th': 'Thailand',
    'tl': 'Timor-leste',
    'tg': 'Togo',
    'tk': 'Tokelau',
    'to': 'Tonga',
    'tt': 'Trinidad And Tobago',
    'tn': 'Tunisia',
    'tr': 'Turkey',
    'tm': 'Turkmenistan',
    'tc': 'Turks And Caicos Islands',
    'tv': 'Tuvalu',
    'ug': 'Uganda',
    'ua': 'Ukraine',
    'ae': 'United Arab Emirates',
    'gb': 'United Kingdom',
    'um': 'United States Minor Outlying Islands',
    'us': 'United States',
    'uy': 'Uruguay',
    'uz': 'Uzbekistan',
    'vu': 'Vanuatu',
    'va': 'Vatican City State',
    've': 'Venezuela',
    'vn': 'Viet Nam',
    'vg': 'Virgin Islands (British)',
    'vi': 'Virgin Islands (U.S.)',
    'wf': 'Wallis And Futuna Islands',
    'eh': 'Western Sahara',
    'ye': 'Yemen',
    'zm': 'Zambia',
    'zw': 'Zimbabwe'
  }
};

export const COUNTRIES_NL = {
  'COUNTRY': {
    'ax': 'Aaland-eilanden',
    'af': 'Afghanistan',
    'al': 'Albanië',
    'dz': 'Algerije',
    'as': 'Amerikaans-Samoa',
    'ad': 'Andorra',
    'ao': 'Angola',
    'ai': 'Anguilla',
    'aq': 'Antarctica',
    'ag': 'Antigua en Barbuda',
    'ar': 'Argentinië',
    'am': 'Armenië',
    'aw': 'Aruba',
    'au': 'Australië',
    'at': 'Oostenrijk',
    'az': 'Azerbeidzjan',
    'bs': 'Bahama\'s',
    'bh': 'Bahrein',
    'bd': 'Bangladesh',
    'bb': 'Barbados',
    'by': 'Belarus; Wit-Rusland',
    'be': 'België',
    'bz': 'Belize',
    'bj': 'Benin',
    'bm': 'Bermuda',
    'bt': 'Bhutan',
    'bo': 'Bolivia',
    'ba': 'Bosnië en Herzegovina',
    'bw': 'Botswana',
    'bv': 'Bouveteiland',
    'br': 'Brazilië',
    'io': 'Brits Territorium in de Indische Oceaan',
    'bn': 'Brunei',
    'bg': 'Bulgarije',
    'bf': 'Burkina Faso',
    'bi': 'Burundi',
    'kh': 'Cambodja',
    'cm': 'Kameroen',
    'ca': 'Canada',
    'cv': 'Kaapverdië',
    'bq': 'Nedlandse Caribbean',
    'ky': 'Caymaneilanden',
    'cf': 'Centraal-Afrikaanse Republiek',
    'td': 'Tsjaad',
    'cl': 'Chile',
    'cn': 'China',
    'cx': 'Christmaseiland',
    'cc': 'Cocoseilanden',
    'co': 'Colombia',
    'km': 'Comoren',
    'cg': 'Congo',
    'cd': 'Democratische Republiek Congo',
    'ck': 'Cookeilanden',
    'cr': 'Costa Rica',
    'ci': 'Cote Divoire',
    'hr': 'Kroatië ',
    'cu': 'Cuba',
    'cw': 'Curacao',
    'cy': 'Cyprus',
    'cz': 'Tsjechië',
    'dk': 'Denemarken',
    'dj': 'Djibouti',
    'dm': 'Dominica',
    'do': 'Dominicaanse Republiek',
    'ec': 'Ecuador',
    'eg': 'Egypte',
    'sv': 'El Salvador',
    'gq': 'Equatoriaal-Guinea',
    'er': 'Eritrea',
    'ee': 'Estland',
    'et': 'Ethiopië',
    'fk': 'Falklandeilanden',
    'fo': 'Faeröer',
    'fj': 'Fiji',
    'fi': 'Finland',
    'fr': 'Frankrijk',
    'gf': 'Frans-Guyana',
    'pf': 'Frans-Polynesië',
    'tf': 'Franse Gebieden in de zuidelijke Indische Oceaan',
    'ga': 'Gabon',
    'gm': 'Gambia',
    'ge': 'Georgië',
    'de': 'Duitsland',
    'gh': 'Ghana',
    'gi': 'Gibraltar',
    'gr': 'Griekenland',
    'gl': 'Groenland',
    'gd': 'Grenada',
    'gp': 'Guadeloupe',
    'gu': 'Guam',
    'gt': 'Guatemala',
    'gg': 'Guernsey',
    'gn': 'Guinee',
    'gw': 'Guinee-Bissau',
    'gy': 'Guyana',
    'ht': 'Haiti',
    'hm': 'Heard- en McDonaldeilanden',
    'hn': 'Honduras',
    'hk': 'Hongkong',
    'hu': 'Hongarije',
    'is': 'Ierland',
    'in': 'India',
    'id': 'Indonesië',
    'ir': 'Iran ',
    'iq': 'Irak',
    'ie': 'IJsland',
    'im': 'Eiland Man',
    'il': 'Israël',
    'it': 'Italië',
    'jm': 'Jamaica',
    'jp': 'Japan',
    'je': 'Jersey',
    'jo': 'Jordanië',
    'kz': 'Kazachstan',
    'ke': 'Kenia; Kenya',
    'ki': 'Kiribati',
    'kp': 'Noord-Korea ',
    'kr': 'Zuid-Korea',
    'xk': 'Kosovo',
    'kw': 'Koeweit',
    'kg': 'Kirgizië; Kirgizstan',
    'la': 'Laos',
    'lv': 'Letland',
    'lb': 'Lebanon',
    'ls': 'Lesotho',
    'lr': 'Liberia',
    'ly': 'Libië',
    'li': 'Liechtenstein',
    'lt': 'Litouwen',
    'lu': 'Luxembourg',
    'mo': 'Macau',
    'mk': 'Voormalige Joegoslavische Republiek Macedonië',
    'mg': 'Madagaskar',
    'mw': 'Malawi',
    'my': 'Maleisië',
    'mv': 'Maldiven',
    'ml': 'Mali',
    'mt': 'Malta',
    'mh': 'Marshalleilanden',
    'mq': 'Martinique',
    'mr': 'Mauritanië',
    'mu': 'Mauritius',
    'yt': 'Mayotte',
    'mx': 'Mexico',
    'fm': 'Micronesia',
    'md': 'Moldavië',
    'mc': 'Monaco',
    'mn': 'Mongolië',
    'me': 'Montenegro',
    'ms': 'Montserrat',
    'ma': 'Marokko',
    'mz': 'Mozambique',
    'mm': 'Myanmar',
    'na': 'Namibië',
    'nr': 'Nauru',
    'np': 'Nepal',
    'an': 'Nederlandse Antillen',
    'nl': 'Nederland',
    'nc': 'Nieuw-Caledonië',
    'nz': 'Nieuw-Zeeland',
    'ni': 'Nicaragua',
    'ne': 'Niger',
    'ng': 'Nigeria',
    'nu': 'Niue',
    'nf': 'Norfolkeiland',
    'mp': 'Noordelijke Marianen',
    'no': 'Noorwegen',
    'om': 'Oman',
    'pk': 'Pakistan',
    'pw': 'Palau',
    'ps': 'Palestina',
    'pa': 'Panama',
    'pg': 'Papoea-Nieuw-Guinea',
    'py': 'Paraguay',
    'pe': 'Peru',
    'ph': 'Filipijnen',
    'pn': 'Pitcairneilanden',
    'pl': 'Polen',
    'pt': 'Portugal',
    'pr': 'Puerto Rico',
    'qa': 'Qatar',
    're': 'Réunion',
    'ro': 'Roemenië',
    'ru': 'Rusland',
    'rw': 'Rwanda',
    'sh': 'Sint-Helena',
    'kn': 'Saint Kitts en Nevis',
    'lc': 'Saint Lucia',
    'pm': 'Saint-Pierre en Miquelon',
    'vc': 'Saint Vincent en de Grenadines',
    'ws': 'Samoa',
    'bl': 'Sint-Bartholomeus',
    'sm': 'San Marino',
    'st': 'Sao Tomé en Principe',
    'sa': 'Saudi-Arabië',
    'sn': 'Senegal',
    'cs': 'Servië en Montenegro',
    'rs': 'servië',
    'sc': 'Seychellen',
    'sl': 'Sierra Leone',
    'sg': 'Singapore',
    'sx': 'Sint Maarten',
    'sk': 'Slowakije',
    'si': 'Slovenië',
    'sb': 'Salomonseilanden',
    'so': 'Somalië',
    'za': 'Zuid-Afrika',
    'gs': 'Zuid-Georgië en Zuidelijke Sandwicheilanden',
    'ss': 'Zuid-Soedan',
    'es': 'Spanje',
    'lk': 'Sri Lanka',
    'sd': 'Sudan',
    'sr': 'Suriname',
    'sj': 'Svalbard en Jan Mayen',
    'sz': 'Swaziland',
    'se': 'Zweden',
    'ch': 'Zwitserland',
    'sy': 'Syrië',
    'tw': 'Taiwan',
    'tj': 'Tadzjikistan',
    'tz': 'Tanzania',
    'th': 'Thailand',
    'tl': 'Oost-Timor',
    'tg': 'Togo',
    'tk': 'Tokelau-eilanden',
    'to': 'Tonga',
    'tt': 'Trinidad en Tobago',
    'tn': 'Tunesië',
    'tr': 'Turkije',
    'tm': 'Turkmenistan',
    'tc': 'Turks- en Caicoseilanden',
    'tv': 'Tuvalu',
    'ug': 'Uganda',
    'ua': 'Oekraïne',
    'ae': 'Verenigde Arabische Emiraten',
    'gb': 'Verenigd Koninkrijk',
    'um': 'Amerikaanse ondergeschikte afgelegen eilanden',
    'us': 'Verenigde Staten',
    'uy': 'Uruguay',
    'uz': 'Oezbekistan',
    'vu': 'Vanuatu',
    'va': 'Vaticaanstad',
    've': 'Venezuela',
    'vn': 'Vietnam',
    'vg': 'Britse Maagdeneilanden',
    'vi': 'Amerikaanse Maagdeneilanden',
    'wf': 'Wallis en Futuna',
    'eh': 'Westelijke Sahara',
    'ye': 'Jemen',
    'zm': 'Zambia',
    'zw': 'Zimbabwe'
  }
};



// WEBPACK FOOTER //
// ./src/app/translation/i18n/countries.ts